export default __webpack_public_path__ + "i18n/translation-hi.2d283265.json";